import { Box } from "@mui/material";
import PageTitle from "../../../components/PageTitle";
import SearchField from "../../../components/ui/SearchField";
import EmptyState from "../../../components/ui/EmptyState";
import ChoiceChips from "../../../components/ui/ChoiceChips";
import { useTutorials } from "./use-tutorials";
import FeaturedTutorial from "./components/FeaturedTutorial";
import TutorialCard from "./components/TutorialCard";
import TutorialPlayerModal from "./components/TutorialPlayerModal";

export const TutorialPage = () => {
  const {
    loading,
    search,
    setSearch,
    selectedCategory,
    setSelectedCategory,
    selectedVideo,
    setSelectedVideo,
    enabled,
    featured,
    categoryOptions,
    gridItems,
    allFiltered,
  } = useTutorials();

  const noResults = gridItems.length === 0 && search.trim() && allFiltered.length === 0;
  const hideGrid = gridItems.length === 0 && !search.trim() && enabled.length <= 1;

  return (
    <Box sx={{ width: "100%", p: { xs: "18px 16px 24px", md: 4 } }}>
      <PageTitle title="Tutoriais" />

      {!loading && enabled.length > 0 && (
        <Box sx={{ maxWidth: 900, mx: "auto", mb: 3 }}>
          <SearchField value={search} onChange={setSearch} placeholder="Buscar tutoriais..." />
        </Box>
      )}

      {!loading && categoryOptions && (
        <Box sx={{ maxWidth: 900, mx: "auto", mb: 3 }}>
          <ChoiceChips options={categoryOptions} value={selectedCategory} onChange={setSelectedCategory} />
        </Box>
      )}

      {!loading && featured && !search.trim() && <FeaturedTutorial tutorial={featured} onPlay={() => setSelectedVideo(featured)} />}

      {!loading &&
        (noResults ? (
          <Box sx={{ maxWidth: 900, mx: "auto" }}>
            <EmptyState
              title="Nenhum tutorial encontrado"
              description="Tente palavras-chave diferentes."
              actionLabel="Limpar busca"
              onAction={() => setSearch("")}
            />
          </Box>
        ) : hideGrid ? null : (
          <Box sx={{ maxWidth: 900, mx: "auto", display: "flex", flexDirection: "column", gap: 2 }}>
            {gridItems.map((tutorial, index) => (
              <Box key={tutorial.id ?? index} sx={{ width: "100%" }}>
                <TutorialCard tutorial={tutorial} onPlay={() => setSelectedVideo(tutorial)} />
              </Box>
            ))}
          </Box>
        ))}

      {!loading && enabled.length === 0 && (
        <Box sx={{ maxWidth: 900, mx: "auto" }}>
          <EmptyState title="Nenhum tutorial disponível" description="Em breve novos conteúdos serão publicados aqui." />
        </Box>
      )}

      <TutorialPlayerModal video={selectedVideo} onClose={() => setSelectedVideo(null)} />
    </Box>
  );
};
